import { useRef, useEffect, useState } from 'react';

const videos = [
  {
    id: 'KOStJKU7XNE',
    title: '애틀란타 부동산 투자 가이드',
    subtitle: 'Atlanta Real Estate Investment Guide',
  },
  {
    id: 'B19Rj_LGpGE',
    title: '둘루스 & 스와니 주택 시장 분석',
    subtitle: 'Duluth & Suwanee Housing Market Analysis',
  },
];

export default function VideoSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="videos" className="py-24 bg-[#F8F6F1]">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#B8963E] text-xs font-bold tracking-widest uppercase mb-3">
            Video Resources · 영상 자료
          </p>
          <h2 className="font-['Playfair_Display'] text-[#1A1A1A] text-3xl lg:text-4xl font-bold mb-4">
            Real Estate Insights
          </h2>
          <p className="text-[#666] text-sm max-w-xl mx-auto">
            애틀란타 부동산 시장에 대한 최신 정보와 전문가 인사이트를 영상으로 확인하세요.
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {videos.map((video, index) => (
            <div
              key={video.id}
              className="rounded-lg overflow-hidden bg-white"
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              {/* Responsive iframe wrapper */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              {/* Caption */}
              <div className="px-5 py-4 border-t border-[#F0ECE3]">
                <p className="font-['Playfair_Display'] text-[#1A1A1A] font-semibold text-base leading-snug">
                  {video.title}
                </p>
                <p className="text-[#B8963E] text-xs font-medium mt-1">{video.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom link */}
        <div className="mt-10 text-center">
          <a
            href="https://www.youtube.com/@prinstonrealtygroup-jx8ij"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 text-[#B8963E] hover:text-[#A07830] text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-youtube-fill text-lg"></i>
            </span>
            더 많은 영상 보기 · Watch More Videos
          </a>
        </div>
      </div>
    </section>
  );
}
